<template>
    <nav class="bg-main">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex justify-between h-16">
                <div class="w-full flex justify-between">
                    <div class="flex-shrink-0 flex items-center">
                        <img class="block lg:hidden h-8 w-auto" src="/static/svg/logo.svg" alt="" />
                        <img class="hidden lg:block h-8 w-auto" src="/static/svg/logo.svg" alt="" />
                    </div>
                    <div class="hidden md:ml-6 md:flex md:items-center">
                        <router-link
                            tag="a"
                            href="#"
                            class="menu-item ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-white"
                            :class="{'selected': $route.name === route.name}"
                            v-for="route in routes"
                            :key="route.title"
                            :to="{name: route.name}"
                        >
                            {{ route.title }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .menu-item {

        &.selected {
            background: rgba(0, 0, 0, 0.15);
            background: #fff;
            color: $color--main;
        }
    }

</style>

<script>
export default {
    data () {
        return {
            userHasScrolled: false,
            progressWidth: 0,
            routes: [
                {
                    title: 'Startside',
                    name: 'Index'
                },
                {
                    title: 'Historik',
                    name: 'History'
                },
                {
                    title: 'Statistik',
                    name: 'Stats'
                },
                {
                    title: 'Indstillinger',
                    name: 'Settings'
                }
            ]
        }
    },
    created () {
        window.addEventListener('scroll', this.checkScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.checkScroll)
    },
    methods: {
        checkScroll () {
            let scrollHeight = document.body.scrollHeight - window.innerHeight
            let offset = window.pageYOffset
            this.progressWidth = (offset / scrollHeight) * 100
            if (window.pageYOffset > 50) {
                this.userHasScrolled = true
            } else {
                this.userHasScrolled = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// menu.vue?ba8e6f30